export default __webpack_public_path__ + "static/media/HT.282b2b39.svg";